import * as React from 'react';
import { FavoriteButton } from '../../components/Favorite/FavoriteButton';
import { Header } from '../../components/FullscreenPopup';
import { TShowPhoneAction } from '../../types/analytics/call';
import { IFavoriteActionTypes } from '../../types/analytics/favorite';
import { HeaderCall } from '../Call/HeaderCall';
import { FavoriteContainer } from '../Favorite';

export interface IAsideContentPopupHeaderContainerProps {
  callAction: TShowPhoneAction;
  favoriteActions: IFavoriteActionTypes;
  dynamicCallTrackingTitle: string;
  onClose(): void;
}

export function AsideContentPopupHeader({
  onClose,
  callAction,
  favoriteActions,
  dynamicCallTrackingTitle,
}: IAsideContentPopupHeaderContainerProps) {
  return (
    <Header
      onClose={onClose}
      favorite={<FavoriteContainer button={FavoriteButton} eventActions={favoriteActions} />}
      call={<HeaderCall placeType={dynamicCallTrackingTitle} eventAction={callAction} />}
    />
  );
}
